import * as React from "react";
import { useTranslation } from "react-i18next";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import { Dialog, DialogContent } from "@/components/ui/dialog";

export interface CommandEntry {
  id: string;
  label: string;
  group?: string;
  onSelect: () => void;
}

export interface CommandPaletteProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  entries: CommandEntry[];
}

export function CommandPalette({ open, onOpenChange, entries }: CommandPaletteProps) {
  const { t } = useTranslation();
  const defaultGroup = t("common.command-palette.default-group");
  const groups = React.useMemo(() => {
    const out = new Map<string, CommandEntry[]>();
    for (const e of entries) {
      const key = e.group ?? defaultGroup;
      const list = out.get(key) ?? [];
      list.push(e);
      out.set(key, list);
    }
    return [...out.entries()];
  }, [entries, defaultGroup]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="overflow-hidden p-0">
        <Command>
          <CommandInput placeholder={t("common.search.command-placeholder")} />
          <CommandList>
            <CommandEmpty>{t("common.command-palette.empty")}</CommandEmpty>
            {groups.map(([group, items]) => (
              <CommandGroup key={group} heading={group}>
                {items.map((e) => (
                  <CommandItem
                    key={e.id}
                    onSelect={() => {
                      e.onSelect();
                      onOpenChange(false);
                    }}
                  >
                    {e.label}
                  </CommandItem>
                ))}
              </CommandGroup>
            ))}
          </CommandList>
        </Command>
      </DialogContent>
    </Dialog>
  );
}
